import { Injectable } from '@angular/core';
import { Utils } from '@zaoblako/shared/common/classes/utils';
import { TemplateEntityVariableEnum } from '@zaoblako/shared/common/enums/template.entity.variable.enum';
import { TemplateEngineVariablesValuesInterface } from '@zaoblako/shared/common/interfaces/template.engine.variables.values.interface';
import * as moment from 'moment-timezone';
// @ts-ignore
import * as stringPlaceholder from 'string-placeholder';

@Injectable({
  providedIn: 'root'
})
export class TemplateEntityVariableService {
  private readonly VARIABLE_OPEN = '{{';
  private readonly VARIABLE_CLOSE = '}}';

  public parse(str: string, values: TemplateEngineVariablesValuesInterface = {}): string {
    if (!str) {
      return '';
    }

    const { date = new Date(), recipientsName, contragent, company = 'Компания', amountOfDebts = 0 } = values;
    const mDate = moment(date);

    return stringPlaceholder(
      str,
      {
        [TemplateEntityVariableEnum.CONTRAGENT]: contragent || this.quot(TemplateEntityVariableEnum.CONTRAGENT),
        [TemplateEntityVariableEnum.RECIPIENTS_NAME]:
          recipientsName || this.quot(TemplateEntityVariableEnum.RECIPIENTS_NAME),
        [TemplateEntityVariableEnum.COMPANY]: company || this.quot(TemplateEntityVariableEnum.COMPANY),
        [TemplateEntityVariableEnum.DATE]: mDate.format('DD.MM.YYYY'),
        [TemplateEntityVariableEnum.AMOUNT_OF_DEBTS]: Utils.formatFloat(amountOfDebts),
        [TemplateEntityVariableEnum.CURRENT_MONTH]: mDate.format('MMM'),
        [TemplateEntityVariableEnum.PREVIOUS_MONTH]: mDate.clone().subtract(1, 'month').format('MMM'),
        [TemplateEntityVariableEnum.NEXT_MONTH]: mDate.clone().add(1, 'month').format('MMM'),
        [TemplateEntityVariableEnum.CURRENT_MONTH_NUMERIC]: mDate.format('MM'),
        [TemplateEntityVariableEnum.PREVIOUS_MONTH_NUMERIC]: mDate.clone().subtract(1, 'month').format('MM'),
        [TemplateEntityVariableEnum.NEXT_MONTH_NUMERIC]: mDate.clone().add(1, 'month').format('MM'),
        [TemplateEntityVariableEnum.CURRENT_QUARTER]: mDate.format('Q'),
        [TemplateEntityVariableEnum.PREVIOUS_QUARTER]: mDate.clone().subtract(1, 'quarter').format('Q'),
        [TemplateEntityVariableEnum.NEXT_QUARTER]: mDate.clone().add(1, 'quarter').format('Q'),
        [TemplateEntityVariableEnum.CURRENT_YEAR]: mDate.format('YYYY'),
        [TemplateEntityVariableEnum.PREVIOUS_YEAR]: mDate.clone().subtract(1, 'year').format('YYYY'),
        [TemplateEntityVariableEnum.NEXT_YEAR]: mDate.clone().add(1, 'year').format('YYYY')
      },
      {
        before: this.VARIABLE_OPEN,
        after: this.VARIABLE_CLOSE
      }
    );
  }

  private quot(value: any): string {
    return `${this.VARIABLE_OPEN}${value}${this.VARIABLE_CLOSE}`;
  }
}
